import Mock from './mock';
import { getEnv } from 'ecx.saigon.ui.common';
import { claimsByStatus as query } from '../graphql/claims';
import apolloClient from '../../utils/apollo-client';

export default async function (variables) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return await new Promise((resolve) =>
      setTimeout(() => resolve(Mock.data.claimsByStatus), 1000)
    );
  }
  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables,
      fetchPolicy: 'network-only'
    })
  );
  return response.data.claimsByStatus;
}
